import { API } from '../../providers/ApiInterceptorProvider';
import { BtlApplicationSummary } from './types';

export const btlApplicationsApi = {
  getAll: async () => {
    try {
      const { data } = await API.get<BtlApplicationSummary>(`/btl-applications`, {
        params: { applicationType: 'BUY_TO_LET' },
      });
      return data;
    } catch (err: any) {
      throw new Error(err.response.data.message);
    }
  },
};
